import { axiosInstance } from '@configs/axios/axiosInstance';

import type { UpdateProfileIdentityRequest } from './updateProfileIdentity.types';

export async function updateProfileIdentity(
  data: UpdateProfileIdentityRequest
): Promise<void> {
  await axiosInstance.put('/client-profiles/identity-information', data);
}
